export const shell = {
  notFound: {
    title: 'Page not found',
    body: 'That address does not exist.',
    backLink: 'Back to the overview',
  },
  configWarning: {
    /**
     * Rendered through `<Trans>`: `<0>` wraps the bold lead-in, `<1>` and
     * `<2>` wrap the two file names, so each locale can reorder the
     * sentence without breaking the markup.
     */
    body: '<0>Incomplete configuration.</0> Missing {{missing}}. Set them in <1>.env.local</1> for local development (see <2>.env.example</2>), or in the container environment for a deployment.',
  },
  skipToContent: 'Skip to content',
  brandName: 'NOLATR',
  mainNav: 'Main',
  sectionNav: 'Section',
  accountNav: 'Account',
  openMainMenu: 'Open menu',
  closeMainMenu: 'Close menu',
  activeCompany: 'Active company',
  profileStub: {
    title: 'Profile',
    lead: 'Your profile page is on its way — for now this is a placeholder so the shell has somewhere to send you.',
  },
  manageStub: {
    title: 'Manage',
    lead: 'Pick a section from the menu.',
  },
} as const;
